import XHRMock from 'xhr-mock';
import type { CookedPage, RawPage, SessionResponse } from '@fullstory/client-api';
import {
  COOKED_PAGE_RESPONSE,
  RAW_PAGE_RESPONSE,
  SESSION_RESPONSE,
  NETWORK_DATA_REQUEST_RESPONSE,
  AJAX_SETTINGS_RESPONSE,
} from './responses';
import type { NetworkRsp } from '@fullstory/playback-model';
import type { AjaxSettings } from '@fullstory/proto/fs/api/clientapi';
import { cloneDeep } from 'lodash';

export const getCookedPageMock = (
  mock: typeof XHRMock,
  rsps: CookedPage[] = [COOKED_PAGE_RESPONSE],
) => {
  if (rsps.length === 1) {
    mock.get(/\/cookedPage*/, (_, res) => res.status(200).body(rsps[0]));
  } else {
    rsps.forEach(rsp => {
      const cookPageWithPageId = rsp as CookedPage & { PageId: number };
      mock.get(
        new RegExp(`(\\/cookedPage)+.*(PageId=${cookPageWithPageId?.PageId || 0})`),
        (_, res) => res.status(200).body(cloneDeep(rsp)),
      );
    });
  }
};

export const getRawPageMock = (mock: typeof XHRMock, rsp: RawPage = RAW_PAGE_RESPONSE) => {
  mock.get(/\.*.json$/, (_, res) => res.status(200).body(cloneDeep(rsp)));
};

export const getSessionMock = (mock: typeof XHRMock, rsp: SessionResponse = SESSION_RESPONSE) => {
  mock.get(/\/session/, (_, res) => res.status(200).body(cloneDeep(rsp)));
};

export const getSessionNetworkData = (
  mock: typeof XHRMock,
  rsp: NetworkRsp = NETWORK_DATA_REQUEST_RESPONSE,
) => {
  mock.get(/\/export\/network/, (_, res) => res.status(200).body(cloneDeep(rsp)));
};

export const getAjaxSettingsMock = (
  mock: typeof XHRMock,
  rsp: AjaxSettings = AJAX_SETTINGS_RESPONSE,
) => {
  mock.get(/\/settings\/ajax/, (_, res) => res.status(200).body(cloneDeep(rsp)));
};
